import { render, staticRenderFns } from "./SolicitudUnica.vue?vue&type=template&id=48f2ad42"
import script from "./SolicitudUnica.vue?vue&type=script&lang=js"
export * from "./SolicitudUnica.vue?vue&type=script&lang=js"
import style0 from "./SolicitudUnica.vue?vue&type=style&index=0&id=48f2ad42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports